import React from 'react';
import { Space, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../hooks/useTranslation';

const { Text } = Typography;

export interface CancelledQuickActionsProps {
  appointment: {
    id: string;
    status: string;
  };
}

const CancelledQuickActions: React.FC<CancelledQuickActionsProps> = ({
  appointment
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div style={{ 
        textAlign: 'center', 
        padding: '16px',
        backgroundColor: '#fff2f0',
        border: '1px solid #ffccc7',
        borderRadius: '6px'
      }}>
        <CloseCircleOutlined style={{ fontSize: '24px', color: '#ff4d4f', marginBottom: '8px' }} />
        <div>
          <Text strong style={{ color: '#ff4d4f' }}>
            {t('appointments.cancelled') || 'Appointment Cancelled'}
          </Text>
        </div>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {t('appointments.noActionsAvailable') || 'No actions available'}
        </Text>
      </div>
    </Space>
  );
};

export default CancelledQuickActions;
